import styles from './letter-filter.module.scss';
import PropTypes from 'prop-types';

const LetterFilter = ({ checked, disabled, handleChange, id, letter }) => {
	return (
		<div className={styles.container}>
			<input
				checked={checked}
				className={styles.letterFilter}
				disabled={disabled}
				id={id}
				key={letter}
				onChange={handleChange}
				type="checkbox"
				value={letter}
			/>
			<label className={styles.letterFilterLabel} htmlFor={id}>
				{letter}
			</label>
		</div>
	);
};

LetterFilter.propTypes = {
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	handleChange: PropTypes.func.isRequired,
	id: PropTypes.string.isRequired,
	letter: PropTypes.string.isRequired,
};
export default LetterFilter;
